// Generic section container for the Simple page.
// Standardizes vertical rhythm, max-width, and the kicker → headline → body pattern.

export default function Section({
  kicker,
  title,
  lede,
  children,
  tone = 'default',
  className = '',
}) {
  const toneBg = {
    default: 'paper-section paper-section-default',
    soft: 'paper-section paper-section-soft',
    ice: 'paper-section paper-section-ice',
    mint: 'paper-section paper-section-mint',
    dark: 'paper-section-dark text-white',
  }[tone];
  const toneKicker = tone === 'dark' ? 'text-ice-300' : 'text-ice-700';
  const toneLede = tone === 'dark' ? 'text-carbon-300' : 'text-carbon-500';

  return (
    <section className={`${toneBg} border-t border-carbon-100/70 ${className}`}>
      <div className="max-w-6xl mx-auto px-6 py-16 md:py-20">
        {kicker && <p className={`caption ${toneKicker}`}>{kicker}</p>}
        {title && <h2 className="h2 mt-4">{title}</h2>}
        {lede && <p className={`body-lg mt-5 max-w-3xl ${toneLede}`}>{lede}</p>}
        {children && <div className="mt-10">{children}</div>}
      </div>
    </section>
  );
}
